export default "Birthdate is in an unrecognized format. Please try: <br />\r\n<br /> mm/dd/yyyy";